package com.nonopn.skywatcher.config.buildconfig

import kotlin.String

internal object BuildKonfig {
  public val googleAuthServerId: String =
      "393180423504-m80iuhi2l2ahq7ch5rfhq6ncv2ucrk3e.apps.googleusercontent.com"

  public val openWeatherMapApiKey: String = "01c8d29805d6c1845dfdd5994791d453"

  public val sentryClient: String =
      "https://540c5c468329f9195a0ee8adcf1d78d9@o4507447036608512.ingest.de.sentry.io/4509072152854608"

  public val sentrySecondary: String =
      "https://f137ba3e5a9f221482a559020f796165@o4507447036608512.ingest.de.sentry.io/4509072145317968"

  public val version: String = "0.0.5"
}
